import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { useCallback, useEffect } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Subconta } from "../../../../domain/models/subconta";
import { SubcontaForm, SubcontaSchema } from "../../../schemas/Subconta_lista/cadastro_subconta";
import { DropDownSubconta } from "../../../../../../common/components/dropdown_subconta";
import { FormSwitchInput } from "../../../../../../common/components/masked_inputs/react_forms/form_switch_input";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";
import { isNotNullOrUndefined } from "../../../../../../common/utils/utils";

type props = {
    open: boolean,
    saving: boolean,
    selectedSubconta?: Subconta,

    onOpenChangeHistory: (id: number, tabelaTipo: LogTipoTabela) => void,
    onSubmit: (form: SubcontaForm) => void,
    onClose: () => void,

}

export const SubcontaCadastroModal = ({
    open,
    saving,
    selectedSubconta,
    onOpenChangeHistory,
    onClose,
    onSubmit,

}: props) => {

    const hookForm = useForm<SubcontaForm>({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        resolver: zodResolver(SubcontaSchema),
    });

    useEffect(() => {

        if (selectedSubconta) {
            hookForm.setValue('idSubcontaPai', selectedSubconta.idSubcontaPai);
            hookForm.setValue('codigo', selectedSubconta.codigo);
            hookForm.setValue('descricao', selectedSubconta.descricao);
            hookForm.setValue('ativo', selectedSubconta.ativo);

        } else {
            hookForm.setValue('idSubcontaPai', undefined);
            hookForm.setValue('codigo', '');
            hookForm.setValue('descricao', '');
            hookForm.setValue('ativo', true);


        }
    }, [selectedSubconta, hookForm]);

    const handleSubmit = useCallback((form: SubcontaForm) => {
        if (!saving) {
            onSubmit(form);
            hookForm.reset();
        }

    }, [saving, onSubmit, hookForm]);

    const handleClose = useCallback(() => {
        if (!saving) onClose();
    }, [saving, onClose]);

    const handleChangeHistory = useCallback(() => {
        if (selectedSubconta) {
            onOpenChangeHistory(selectedSubconta.idSubconta ?? 0, LogTipoTabela.SUBCONTA);
        }
    }, [selectedSubconta, onOpenChangeHistory]);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            slotProps={{
                paper: {
                    component: 'form',
                    sx: { width: 400 },
                    onSubmit: hookForm.handleSubmit(handleSubmit)
                }

            }}
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "35rem",
                    },
                },
            }}>

            <DialogTitle>
                Subconta Cadastro
            </DialogTitle>

            <DialogContent>
                <ModalLoading loading={saving}  >
                    <FormContainer title={"Informações"} arrangement="fullRow">
                        <>
                            <div className="flex items-center justify-between">
                                <label className="font-medium text-gray-700">Ativo?</label>
                                <FormSwitchInput
                                    activeLabel="Sim"
                                    inactiveLabel="Não"
                                    name="ativo"
                                    readOnly={saving}
                                    reactHookForm={hookForm}
                                />
                            </div>

                            <DropDownSubconta
                                name='idSubcontaPai'
                                label='Subconta Principal'
                                reactHookForm={hookForm}
                            />

                            <DefaultFormInput
                                name='codigo'
                                label='Código'
                                readOnly={false}
                                required={true}
                                reactHookForm={hookForm}
                            />
                            <DefaultFormInput
                                name='descricao'
                                label='Descrição'
                                readOnly={false}
                                required={true}
                                reactHookForm={hookForm}
                            />

                        </>
                    </FormContainer>

                </ModalLoading>
            </DialogContent>

            <DialogActions>
                <div className="w-full h-full items-center justify-between flex p-4 gap-4">
                    <div>
                        {
                            isNotNullOrUndefined(selectedSubconta) &&
                            <PrimaryButton
                                buttonColor="yellow"
                                onClick={handleChangeHistory}>
                                <span className="text-xs">
                                    Historico de alterações
                                </span>
                            </PrimaryButton>
                        }
                    </div>

                    <div className="flex flex-row gap-2">
                        <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                            <h1
                                className="text-sm text-black dark:text-white"
                                onClick={handleClose}>
                                Cancelar
                            </h1>
                        </div>

                        <div className="w-[120px]">
                            {saving ? (
                                <PrimaryButton
                                    buttonColor="primary-green">
                                    Salvando...
                                </PrimaryButton>
                            ) : (
                                <PrimaryButton
                                    type="submit"
                                    buttonColor="primary-green">
                                    Salvar
                                </PrimaryButton>
                            )}
                        </div>
                    </div>
                </div>
            </DialogActions>

        </Dialog>
    );
}